<template>
  <div style="width: 450px">
    <template v-if="loading">
      <small>Informações sobre o estatuto</small>
      <br>
      Carregando...
    </template>
    <template v-else>
      <div v-if="!document" class="">
        <small>Turma com Estatuto?</small>
        <br>
        {{ document ? 'SIM' : 'NÃO' }}
      </div>
      <div v-else class="">
        <small>Status do estatuto</small>
        <br>
        <v-chip small :color="statusColor">{{ status || 'Carregando...' }}</v-chip>
        <!-- Botão Enviar Estatuto - aparece quando não tem link ainda -->
        <v-btn
          v-if="document && !link && !signedIn"
          x-small
          color="primary"
          class="ml-2"
          :loading="sendingStatute"
          @click="sendStatute"
        >
          <v-icon left small>mdi-send</v-icon>
          Enviar Estatuto
        </v-btn>
      </div>
      <div v-if="signedIn" class="">
        <small>Assinado em</small>
        <br>
        {{ signedIn | moment('DD/MM/YYYY') }}
      </div>
      <div v-else-if="link" class="">
        <small>Link de assinatura</small>
        <br>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              x-small
              outlined
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="copyLinkToClipboard(link.short_link || link)"
            >
              Copiar link
              <v-icon right small>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>{{ link.short_link || link }}</span>
        </v-tooltip>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  name: 'participantDocumentStatus',
  props: ['celebrationId', 'email', 'participantId', 'participantName'],
  data: () => ({
    loading: false,
    document: null,
    status: '',
    statusColor: 'mute',
    signedIn: '',
    link: '',
    sendingStatute: false
  }),
  computed: {
    documentLink () {
      if (this.document) {
        return `https://painel.autentique.com.br/documentos/${this.document}`
      }
      return ''
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    async sendStatute () {
      if (!this.document) {
        this.SET_SNACKBAR({ text: 'Nenhum estatuto configurado para esta turma' })
        return
      }

      this.sendingStatute = true
      try {
        const response = await axios.post('https://n8n.heppi.io/webhook/add-signer-autentique', {
          documentId: this.document,
          email: this.email,
          name: this.participantName || this.email
        })

        // Extrai o short_link da resposta
        let shortLink = null
        const data = response.data

        if (typeof data === 'string' && data.startsWith('http')) {
          shortLink = data
        } else if (data?.short_link) {
          shortLink = data.short_link
        } else if (data?.data?.createLinkToSignature?.short_link) {
          shortLink = data.data.createLinkToSignature.short_link
        } else if (Array.isArray(data) && data[0]?.data?.createLinkToSignature?.short_link) {
          shortLink = data[0].data.createLinkToSignature.short_link
        }

        if (shortLink) {
          this.link = { short_link: shortLink }
          this.status = 'Email entregue'
          this.statusColor = 'warning'
          this.copyLinkToClipboard(shortLink)
        } else {
          console.error('Resposta do servidor:', data)
          this.SET_SNACKBAR({ text: 'Erro: Link não retornado pelo servidor' })
        }
      } catch (error) {
        console.error('Erro ao enviar estatuto:', error)
        this.SET_SNACKBAR({ text: 'Erro ao enviar o estatuto. Tente novamente.' })
      } finally {
        this.sendingStatute = false
      }
    },
    copyLinkToClipboard (text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.SET_SNACKBAR({ text: 'Link copiado para a área de transferência!' })
        } else {
          this.SET_SNACKBAR({ text: 'Não foi possível copiar. Link: ' + text })
        }
      } catch (err) {
        console.error('Erro ao copiar:', err)
        this.SET_SNACKBAR({ text: 'Não foi possível copiar. Link: ' + text })
      }

      document.body.removeChild(textArea)
    },
    getData () {
      this.loading = true
      this.$firestore.collection('settings').doc(this.celebrationId).get()
        .then((snapshot) => {
          const data = snapshot.data()
          this.document = (data && data.document) || null
          const exceptionalSignatures = (data && data.signatures) || {}
          const exceptionalEmail = exceptionalSignatures[this.participantId] || ''

          if (this.document) {
            this.$store.dispatch('firebaseApi', `autentiquedoc?documentId=${this.document}`)
              .then(async response => {
                if (response.signatures) {
                  const matchSign = response.signatures.find(s => s.email === this.email || s.email === exceptionalEmail)
                  if (matchSign) {
                    if (matchSign.signed) this.status = 'Assinado'
                    else if (matchSign.viewed) this.status = 'Visualizado'
                    else if (matchSign.email_events && matchSign.email_events.opened) this.status = 'Email aberto'
                    else if (matchSign.email_events && matchSign.email_events.delivered) this.status = 'Email entregue'
                    else if (matchSign.email_events && matchSign.email_events.refused) this.status = 'Email com erro'

                    if (matchSign.signed) this.statusColor = 'success'
                    else if (matchSign.email_events && matchSign.email_events.refused) this.statusColor = 'error'
                    else this.statusColor = 'warning'

                    this.signedIn = matchSign.signed ? matchSign.signed.created_at : ''
                    this.link = matchSign.link || ''
                  } else if (data.alternativeDocuments && data.alternativeDocuments.length > 0) {
                    for (const index in data.alternativeDocuments) {
                      const documentId = data.alternativeDocuments[index]
                      await this.$store.dispatch('firebaseApi', `autentiquedoc?documentId=${documentId}`)
                        .then(resp => {
                          if (resp.signatures) {
                            const matchSign = resp.signatures.find(s => s.email === this.email || s.email === exceptionalEmail)
                            if (matchSign) {
                              if (matchSign.signed) this.status = 'Assinado'
                              else if (matchSign.viewed) this.status = 'Visualizado'
                              else if (matchSign.email_events && matchSign.email_events.opened) this.status = 'Email aberto'
                              else if (matchSign.email_events && matchSign.email_events.delivered) this.status = 'Email entregue'
                              else if (matchSign.email_events && matchSign.email_events.refused) this.status = 'Email com erro'

                              if (matchSign.signed) this.statusColor = 'success'
                              else if (matchSign.email_events && matchSign.email_events.refused) this.statusColor = 'error'
                              else this.statusColor = 'warning'

                              this.signedIn = matchSign.signed ? matchSign.signed.created_at : ''
                              this.link = matchSign.link || ''
                            }
                          }
                        })

                      if (!this.status) {
                        this.status = 'Não enviado'
                        this.statusColor = 'error'
                        this.signedIn = ''
                        this.link = ''
                      }
                    }
                  } else {
                    this.status = 'Não enviado'
                    this.statusColor = 'error'
                    this.signedIn = ''
                    this.link = ''
                  }
                }
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            this.loading = false
          }
        })
        .catch(() => {
          this.SET_SNACKBAR({ text: 'Não foi possivel trazer as configurações, tente novamente' })
          this.loading = false
        })
    }
  },
  created () {
    this.getData()
  }
}
</script>
